import { render, staticRenderFns } from "./lorepointinfolist.vue?vue&type=template&id=1fc5078e&scoped=true"
import script from "./lorepointinfolist.vue?vue&type=script&lang=js"
export * from "./lorepointinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc5078e",
  null
  
)

export default component.exports